import React from "react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SimpleSlider from "./Slider";
import TotalPrice from "./TotalPrice";

function Gallery() {
	return <div className="flex picture-side">
		<SimpleSlider />
        <TotalPrice />
	</div>;
}

export default Gallery;
